'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _treatAdminForm = require('./treat-admin-form.html');

var _treatAdminForm2 = _interopRequireDefault(_treatAdminForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _treatAdminForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administration: '<',
    administrations: '<',
    units: '<',
    animalTypes: '<',
    frequencies: '<',
    submitTitle: '@',
    unitsDisplay: '<',
    administrationChanged: '&',
    index: '<',
    showAdditionalButton: '<'
  },
  controller: function () {
    function TreatAdminFormComponent(AnimalTypeService, EventEmitter) {
      'ngInject';

      _classCallCheck(this, TreatAdminFormComponent);

      Object.assign(this, {
        AnimalTypeService: AnimalTypeService,
        EventEmitter: EventEmitter
      });
    }

    _createClass(TreatAdminFormComponent, [{
      key: 'onSubmit',
      value: function onSubmit(shouldClose) {
        var administration = _extends({
          Isloading: false,
          MinWeight: this.AnimalTypeService.minimumAnimalWeight(this.administration.Species),
          MaxWeight: this.AnimalTypeService.maximumAnimalWeight(this.administration.Species),
          DoseAmount: 1,
          DosePerDay: 1.00
        }, this.administration);

        if (!administration.DoseId) {
          this.administrations.push(administration);
        }

        this.administrationChanged(this.EventEmitter({
          administration: administration,
          index: this.index,
          shouldClose: shouldClose
        }));

        this.validateDuplicates();
      }
    }, {
      key: 'getMinimumAnimalWeight',
      value: function getMinimumAnimalWeight(species) {
        return this.AnimalTypeService.minimumAnimalWeight(species);
      }
    }, {
      key: 'getMaximumAnimalWeight',
      value: function getMaximumAnimalWeight(species) {
        return this.AnimalTypeService.maximumAnimalWeight(species);
      }
    }, {
      key: 'calculateAdminDays',
      value: function calculateAdminDays() {
        return Math.round(this.units / (this.administration.DoseAmount * this.administration.DosePerDay));
      }
    }, {
      key: 'validateDuplicates',
      value: function validateDuplicates() {
        var _this = this;

        var isValid = true;

        if (this.administration) {
          var arrayIndex = this.administrations.findIndex(function (d) {
            return d.Isloading === false && d.Species === _this.administration.Species;
          });

          if (arrayIndex !== -1 && arrayIndex !== this.index) {
            isValid = false;
          }
        }

        this.treatAdministrationForm.$setValidity('duplicate', isValid);
      }
    }]);

    return TreatAdminFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/treat-admin-form/treat-admin-form.component.js